import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// Link
// import { HashLink } from 'react-router-hash-link';
import { Link } from "react-router-dom";
import Button from "components/CustomButtons/Button.jsx";

import descriptionStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/descriptionStyle.jsx";

function SectionDescription(props) {
  const { classes } = props;
  return (
    <div className={classNames(classes.aboutDescription, classes.textCenter)}>
      <GridContainer justify="center">
        <GridItem
            md={12}
            sm={12}
            className={classNames(
              classes.mlAuto,
              classes.mrAuto,
              classes.textCenter
            )}
        >

          <Link to="/retail" smooth><Button color="rose" size="sm" round>RETAIL</Button></Link>
          <Link to="/industrial" smooth><Button color="rose" size="sm" round>INDUSTRIAL</Button></Link>
          <Link to="/offices" smooth><Button color="rose" size="sm" round>OFFICES</Button></Link>
          <Link to="/buildings" smooth><Button color="rose" size="sm" round>BUILDINGS</Button></Link>
          <Link to="/hotels" smooth><Button color="rose" size="sm" round>HOTELS</Button></Link>
          <Link to="/malls" smooth><Button color="rose" size="sm" round>SHOPPING CENTERS & MALLS</Button></Link>
          <Link to="/residential" smooth><Button color="rose" size="sm" round>RESIDENTIAL</Button></Link>
          <Link to="/new_development_properties" smooth><Button color="rose" size="sm" round>NEW DEVELOPMENTS</Button></Link>
          <Link to="/urban_lands" smooth><Button color="rose" size="sm" round>URBAN LANDS</Button></Link>
          <Link to="/rural_lands" smooth><Button color="rose" size="sm" round>RURAL LANDS</Button></Link>
          <Link to="/investments" smooth><Button color="rose" size="sm" round>INVESTMENTS</Button></Link>
          <Link to="/offers" smooth><Button color="rose" size="sm" round>BUSINESS OPORTUNITIES</Button></Link>
        </GridItem>
      </GridContainer>


      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto)}
        >
          <h2 className={classes.description}>
            Chosen for our service. Famous for our results
          </h2>
          <h3>Combining our regional market knowledge with industry experience we provide a complete service in all property matters for owners, occupiers, financial institutions, developers and investors.</h3>
          <h5>
            We believe in putting our clients first and deliver forward thinking, effective advice with an approachable manner that ultimately helps you achieve your business objectives and get the most value out of your property.
          </h5>
          <h5>Find your next investment or leasing opportunity. Our listings include office, industrial and retail properties, as well as specialized spaces for multifamily, healthcare, technology and more.</h5>
        </GridItem>

      </GridContainer>
    </div>
  );
}

export default withStyles(descriptionStyle)(SectionDescription);
